import React from 'react';
import Auto from '../../assets/icons/auto.svg';
import Boat from '../../assets/icons/boat.svg';
import Home from '../../assets/icons/home.svg';
import HomeWarranty from '../../assets/icons/homeWarranty.svg';
import Landlord from '../../assets/icons/landlord.svg';
import Motorcycle from '../../assets/icons/motorcycle.svg';
import Pet from '../../assets/icons/pet.svg';
import Renters from '../../assets/icons/renters.svg';
import Umbrella from '../../assets/icons/umbrella.svg';

const Icon = ({ lob }) => {
    const iconMap = {
        auto: Auto,
        boat: Boat,
        condo: Home,
        home: Home,
        homeWarranty: HomeWarranty,
        'Home - Secondary Residence': Home,
        landlord: Landlord,
        motorcycle: Motorcycle,
        pet: Pet,
        rent: Renters,
        umbrella: Umbrella
    };

    const key = Object.keys(iconMap).find(
        basicLOB => lob.toLowerCase().indexOf(basicLOB.toLowerCase()) > -1
    );

    const src = iconMap[key];

    return <img src={src} alt={`${lob} icon`} datacy="lob" />;
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.jsx